// frontend/src/components/PrivateRoute.js
import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

const PrivateRoute = ({ element, adminOnly = false }) => {
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  console.log("PrivateRoute: Checking userInfo:", userInfo);

  if (!userInfo) {
    console.log("PrivateRoute: userInfo is null, redirecting to /login");
    return <Navigate to="/login" />;
  }

  if (adminOnly) {
    console.log("PrivateRoute: adminOnly = true. Checking role...");
    const userRole = userInfo.user?.role || userInfo.role;
    console.log(`PrivateRoute: userRole is ${userRole}`);

    if (userRole === "admin") {
      console.log("PrivateRoute: user is admin, returning element");
      return element;
    } else {
      console.log("PrivateRoute: user not admin, redirecting to /home");
      return <Navigate to="/home" />;
    }
  }

  console.log("PrivateRoute: user is authenticated, returning element");
  return element;
};

export default PrivateRoute;
